module.exports = __webpack_public_path__ + "img/cover-article.30e58ecf.jpg";